import { channels } from "@/mocks/home";

const footerNav = [
  { label: "匿名入口", href: "#entry" },
  { label: "投稿方式", href: "#channels" },
  { label: "热门榜单", href: "#ranking" },
  { label: "审核流程", href: "#process" },
];

const footerAbout = [
  { label: "隐私保护承诺", href: "#privacy" },
  { label: "常见问题", href: "#faq" },
  { label: "投稿须知", href: "#channels" },
  { label: "不予受理范围", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-800">
                <i className="ri-quill-pen-line text-lg" />
              </span>
              <span className="font-heading text-xl tracking-wide text-background-50">黑料投稿</span>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-background-100/80">
              提供黑料投稿的匿名入口与联系方式，支持私信、邮箱及在线表单安全提交。我们始终坚持保护投稿人隐私，让每一条可核验的线索都能被认真对待。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="#channels"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 font-label text-sm text-primary-800 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-send-plane-line" />
                前往匿名入口
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-label text-xs uppercase tracking-[0.3em] text-background-100/60">
              站内导航
            </h3>
            <ul className="mt-5 space-y-3">
              {footerNav.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-background-100/85 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-label text-xs uppercase tracking-[0.3em] text-background-100/60">
              投稿方式
            </h3>
            <ul className="mt-5 space-y-3">
              {channels.map((channel) => (
                <li key={channel.id}>
                  <a
                    href="#channels"
                    className="font-label text-sm text-background-100/85 transition-colors hover:text-background-50"
                  >
                    {channel.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-label text-xs uppercase tracking-[0.3em] text-background-100/60">
              规则与承诺
            </h3>
            <ul className="mt-5 space-y-3">
              {footerAbout.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-background-100/85 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-background-100/60">
              本页仅作信息展示，所有投稿请在对应渠道内完成，请勿在本页直接留痕。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-100/60">
            © 2026 黑料投稿 · 匿名投稿渠道信息页
          </p>
          <p className="font-label text-xs text-background-100/60">
            拒绝人身攻击与未经核实的隐私内容
          </p>
        </div>
      </div>
    </footer>
  );
}